// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomPopup_overlay__Z7BeG {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: CustomPopup_fadeIn__xv9ez 0.2s ease-out;
  }
  
  .CustomPopup_popup__v5x96 {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    width: 100%;
    max-width: 450px;
    overflow: hidden;
    animation: CustomPopup_slideIn__YTkx2 0.3s ease-out;
  }
  
  .CustomPopup_header__HDE4N {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .CustomPopup_title__ftIyh {
    font-size: 18px;
    font-weight: 600;
    color: #1a202c;
    margin: 0;
  }
  
  .CustomPopup_closeButton__qSc6D {
    background: none;
    border: none;
    color: #64748b;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s, color 0.2s;
  }
  
  .CustomPopup_closeButton__qSc6D:hover {
    background-color: #f1f5f9;
    color: #334155;
  }
  
  .CustomPopup_content__L3ePY {
    padding: 20px;
  }
  
  .CustomPopup_message__0lCjA {
    font-size: 14px;
    line-height: 1.5;
    color: #4a5568;
    margin: 0;
  }
  
  .CustomPopup_footer__RqXiS {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 20px;
    border-top: 1px solid #e2e8f0;
  }
  
  .CustomPopup_button__lsruT {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid transparent;
  }
  
  .CustomPopup_primary__av3f6 {
    background-color: #3b82f6;
    color: white;
  }
  
  .CustomPopup_primary__av3f6:hover {
    background-color: #2563eb;
  }
  
  .CustomPopup_secondary__JWzAU {
    background-color: white;
    border-color: #e2e8f0;
    color: #64748b;
  }
  
  .CustomPopup_secondary__JWzAU:hover {
    background-color: #f8fafc;
    border-color: #cbd5e1;
  }
  
  .CustomPopup_danger__bSVtj {
    background-color: #ef4444;
    color: white;
  }
  
  .CustomPopup_danger__bSVtj:hover {
    background-color: #dc2626;
  }
  
  @keyframes CustomPopup_fadeIn__xv9ez {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes CustomPopup_slideIn__YTkx2 {
    from {
      transform: translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  @media (max-width: 640px) {
    .CustomPopup_popup__v5x96 {
      max-width: 90%;
    }
  
    .CustomPopup_footer__RqXiS {
      flex-direction: column;
    }
  
    .CustomPopup_button__lsruT {
      width: 100%;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/uploadAndRecording/CustomPopup.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kDAA+B;EACjC;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mDAAgC;EAClC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":[".overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    animation: fadeIn 0.2s ease-out;\r\n  }\r\n  \r\n  .popup {\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n    width: 100%;\r\n    max-width: 450px;\r\n    overflow: hidden;\r\n    animation: slideIn 0.3s ease-out;\r\n  }\r\n  \r\n  .header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 16px 20px;\r\n    border-bottom: 1px solid #e2e8f0;\r\n  }\r\n  \r\n  .title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #1a202c;\r\n    margin: 0;\r\n  }\r\n  \r\n  .closeButton {\r\n    background: none;\r\n    border: none;\r\n    color: #64748b;\r\n    cursor: pointer;\r\n    padding: 4px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: background-color 0.2s, color 0.2s;\r\n  }\r\n  \r\n  .closeButton:hover {\r\n    background-color: #f1f5f9;\r\n    color: #334155;\r\n  }\r\n  \r\n  .content {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .message {\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n    color: #4a5568;\r\n    margin: 0;\r\n  }\r\n  \r\n  .footer {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 12px;\r\n    padding: 16px 20px;\r\n    border-top: 1px solid #e2e8f0;\r\n  }\r\n  \r\n  .button {\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    border: 1px solid transparent;\r\n  }\r\n  \r\n  .primary {\r\n    background-color: #3b82f6;\r\n    color: white;\r\n  }\r\n  \r\n  .primary:hover {\r\n    background-color: #2563eb;\r\n  }\r\n  \r\n  .secondary {\r\n    background-color: white;\r\n    border-color: #e2e8f0;\r\n    color: #64748b;\r\n  }\r\n  \r\n  .secondary:hover {\r\n    background-color: #f8fafc;\r\n    border-color: #cbd5e1;\r\n  }\r\n  \r\n  .danger {\r\n    background-color: #ef4444;\r\n    color: white;\r\n  }\r\n  \r\n  .danger:hover {\r\n    background-color: #dc2626;\r\n  }\r\n  \r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  @keyframes slideIn {\r\n    from {\r\n      transform: translateY(-20px);\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      transform: translateY(0);\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 640px) {\r\n    .popup {\r\n      max-width: 90%;\r\n    }\r\n  \r\n    .footer {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    .button {\r\n      width: 100%;\r\n    }\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `CustomPopup_overlay__Z7BeG`,
	"fadeIn": `CustomPopup_fadeIn__xv9ez`,
	"popup": `CustomPopup_popup__v5x96`,
	"slideIn": `CustomPopup_slideIn__YTkx2`,
	"header": `CustomPopup_header__HDE4N`,
	"title": `CustomPopup_title__ftIyh`,
	"closeButton": `CustomPopup_closeButton__qSc6D`,
	"content": `CustomPopup_content__L3ePY`,
	"message": `CustomPopup_message__0lCjA`,
	"footer": `CustomPopup_footer__RqXiS`,
	"button": `CustomPopup_button__lsruT`,
	"primary": `CustomPopup_primary__av3f6`,
	"secondary": `CustomPopup_secondary__JWzAU`,
	"danger": `CustomPopup_danger__bSVtj`
};
export default ___CSS_LOADER_EXPORT___;
